import {
	AdminDownloadFileTypeEnum,
	ButtonColorEnum,
	ButtonVariantEnum,
	CostTypeEnum,
	GetTypeEnum,
	LabelTypeEnum,
	ReprintLabelPackageSelectionEnum,
	SnackBarVariants,
	UserRole,
} from '@app/app.enum';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import withSnackBar from '@app/components/core/message.component';
import { CarriersSupportingScanForm } from '@app/constants/carrier-account.constants';
import CustomDialogBox from '@app/components/shared/dialog.component';
import { CollapsedFieldsInJsonView, dateTimeFormatOptions } from '@app/constants';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { AdminShipmentService } from '@app/services/admin-shipment.service';
import { SharedService } from '@app/services/shared.service';
import { ShipmentService } from '@app/services/shipment.service';
import { TrackingService } from '@app/services/tracking.service';
import {
	Box,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	Grid,
	ListItem,
	ListItemText,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	Typography,
} from '@material-ui/core';
import Axios from 'axios';
import * as React from 'react';
import { FormattedDate, FormattedNumber, injectIntl } from 'react-intl';
import ReactJson, { CollapsedFieldProps } from 'react-json-view';
import { AdminManifestService } from '../../services/admin-manifest.service';
import CustomButton from './custom-button.component';
import PageNavigationComponent from './page-navigation.component';

const accountService: AccountService = Injector.get(AccountService);
const shipmentService: ShipmentService = Injector.get(ShipmentService);
const adminManifestService: AdminManifestService = Injector.get(AdminManifestService);
const adminReportService: AdminShipmentService = Injector.get(AdminShipmentService);
const sharedService: SharedService = Injector.get(SharedService);
const trackingService: TrackingService = Injector.get(TrackingService);

class ShipmentDetailComponent extends React.Component<models.IShipmentDetailProps, models.IShipmentDetailState> {
	constructor(props: models.IShipmentDetailProps) {
		super(props);
		this.state = {
			isOpenRefundStatusDialog: false,
			isOpenReprintLabelDialog: false,
			reprintLabelQuantity: ReprintLabelPackageSelectionEnum.Specific,
			reprintPackageNumber: null,
			isShipmentRefundLoading: false,
			isReprintLabelLoading: false,
			packageCurrentPage: 1,
			packageNumber: null,
			packageLoading: false,
			totalPackages: props.shipment.packages.length,
			shipment: props.shipment,
			multiPieceShipments: [],
			isIncludeOtherClientFeeCharges: false,
			isIncludeOtherPartnerFeeCharges: false,
		};
	}

	public componentDidMount() {
		const { shipment } = this.state;
		this.setState((prevState: models.IShipmentDetailState) => ({
			multiPieceShipments: [
				...prevState.multiPieceShipments,
				{
					package: { ...shipment.packages[0] },
					tracking: { ...shipment.tracking },
					postageLabel: { ...shipment.postageLabel },
					rates: shipment.rates ? { ...shipment.rates } : null,
					totalPackages: shipment.packages.length,
					shipmentId: shipment.id,
					accountId: shipment.accountId,
					manifestId: shipment.manifestId,
				},
			],
		}));
	}

	public componentDidUpdate(prevProps: models.IShipmentDetailProps, prevState: models.IShipmentDetailState) {
		if (prevState.shipment !== this.state.shipment) {
			const { shipment, packageNumber } = this.state;

			const multipieceShipmentsPackage = [...this.state.multiPieceShipments];

			multipieceShipmentsPackage[this.state.packageCurrentPage - 1] = {
				package: { ...shipment.packages.find((x) => x.packageNumber === packageNumber) },
				tracking: { ...shipment.tracking },
				postageLabel: { ...shipment.postageLabel },
				rates: shipment.rates ? { ...shipment.rates } : null,
				totalPackages: shipment.packages.length,
				shipmentId: shipment.id,
				accountId: shipment.accountId,
				manifestId: shipment.manifestId,
			};
			this.setState({
				multiPieceShipments: multipieceShipmentsPackage,
				reprintPackageNumber: packageNumber,
			});
		}
	}

	public render() {
		const item = this.state.shipment;
		return (
			<ListItem style={this.props.style}>
				<ListItemText
					primary={
						<React.Fragment>
							<Grid container={true} direction='row' spacing={2}>
								<Grid
									item={true}
									lg={6}
									md={6}
									sm={12}
									xs={12}
									className='pl-5'
									style={{
										paddingLeft: '80px',
									}}
								>
									<Grid container={true} direction='row' justifyContent='space-evenly' spacing={3}>
										<Grid item={true} xs={12} sm={12}>
											<Grid container={true} direction='row'>
												<Grid item={true} xs={6} sm={6}>
													{this.getToAddress(item.toAddress)}
												</Grid>
												<Grid item={true} xs={6} sm={6}>
													{this.getFromAddress(item.fromAddress)}
												</Grid>
											</Grid>
										</Grid>

										<Grid item={true} xs={12} sm={12}>
											{this.getOtherInfo(item)}
										</Grid>

										<Grid item={true} xs={12} sm={12}>
											{this.downloadButtons(item, this.state.multiPieceShipments)}
										</Grid>
									</Grid>
								</Grid>
								<Grid className='pr-5' item={true} lg={6} md={6} sm={12} xs={12}>
									{this.getPackageInformation(this.state.multiPieceShipments[this.state.packageCurrentPage - 1])}
								</Grid>
							</Grid>
						</React.Fragment>
					}
				/>
				<CustomDialogBox
					open={this.state.isOpenRefundStatusDialog}
					dialogTitle={this.props.intl.formatMessage({
						id: 'app.shipment.refund-status-dialog-title',
					})}
					dialogDescription={this.props.intl.formatMessage({
						id: 'app.shipment.refund-status-dialog-text',
					})}
					closeCustomDialog={async (dialogString?: string, isCancel?: boolean) => {
						if (!isCancel) {
							await this.refundShipment(item.id);
						}
						this.setState({
							isShipmentRefundLoading: false,
							isOpenRefundStatusDialog: false,
						});
					}}
					dialogYesButton={this.props.intl.formatMessage({
						id: 'app.common.dialog-confirm-button-text',
					})}
					dialogNoButton={this.props.intl.formatMessage({
						id: 'app.common.dialog-cancel-button-text',
					})}
					loading={this.state.isShipmentRefundLoading}
					disabled={this.state.isShipmentRefundLoading}
				/>
				<Dialog
					open={!!this.state.isOpenReprintLabelDialog}
					onClose={() =>
						this.setState({
							isOpenReprintLabelDialog: false,
						})
					}
				>
					<DialogTitle className='reprint-label-dialog-title'>
						{this.props.intl.formatMessage({
							id: 'app.shipment.reprint-label',
						})}
					</DialogTitle>
					<DialogContent className='pt-2'>
						<Grid container={true} direction='row'>
							<DialogContentText
								component='span'
								children={this.props.intl.formatMessage({
									id: 'app.shipment.reprint-label-dialog-text',
								})}
							/>
						</Grid>
						<Grid container={true} direction='column' spacing={0}>
							<RadioGroup
								defaultValue={ReprintLabelPackageSelectionEnum.Specific}
								name='radio-buttons-group'
								onChange={(e) =>
									this.setState({ reprintLabelQuantity: ReprintLabelPackageSelectionEnum[e.target.value] })
								}
							>
								<Grid item={true} xs={12}>
									<FormControlLabel
										value={ReprintLabelPackageSelectionEnum.All}
										control={<Radio />}
										label={this.props.intl.formatMessage({ id: 'app.shipment.all-packages-label' })}
									/>
								</Grid>
								<Grid item={true} xs={12}>
									<FormControlLabel
										value={ReprintLabelPackageSelectionEnum.Specific}
										control={<Radio />}
										label={this.props.intl.formatMessage({ id: 'app.shipment.package-number' })}
									/>
									<Select
										labelId='demo-simple-select-label'
										id='demo-simple-select'
										value={
											this.state.reprintPackageNumber
												? this.state.reprintPackageNumber
												: this.state.shipment.packages[0].packageNumber
										}
										label='Age'
										defaultValue=''
										onChange={(e) => {
											this.setState({ reprintPackageNumber: Number(e.target.value) });
										}}
									>
										{this.state.shipment.packages.map((x) => (
											<MenuItem key={x.packageNumber} value={x.packageNumber}>
												{x.packageNumber}
											</MenuItem>
										))}
									</Select>
								</Grid>
							</RadioGroup>
						</Grid>
					</DialogContent>
					<DialogActions className='justify-content-center mb-1'>
						{/* Dialog Cancel Button */}
						<CustomButton
							variant={ButtonVariantEnum.Outlined}
							color={ButtonColorEnum.Primary}
							onClick={() => {
								this.setState({
									isOpenReprintLabelDialog: false,
								});
							}}
							buttonText={this.props.intl.formatMessage({
								id: 'app.common.dialog-cancel-button-text',
							})}
							className='mr-4 width-100'
						/>
						{/* Dialog Ok Button */}
						<CustomButton
							className='color-active-background width-100'
							onClick={async () => {
								this.setState({
									isOpenReprintLabelDialog: false,
								});
								let shipmentLabel = null;
								if (this.state.reprintLabelQuantity === ReprintLabelPackageSelectionEnum.All) {
									await shipmentService.getAllLabelsOfShipment(
										this.state.multiPieceShipments[0].shipmentId,
										this.props.axiosCancellationToken
									);
								} else {
									shipmentLabel = await shipmentService.getShipmentLabel(
										this.state.multiPieceShipments[0].shipmentId,
										this.props.axiosCancellationToken,
										this.state.packageNumber
									);
									await this.reprintLabel(this.state.multiPieceShipments[0].shipmentId, shipmentLabel);
								}
							}}
							buttonText={this.props.intl.formatMessage({
								id: 'app.common.dialog-small-okay-button-text',
							})}
							autoFocus={true}
						/>
					</DialogActions>
				</Dialog>
			</ListItem>
		);
	}

	// get package info
	private getPackageInformation = (multiPieceShipment: models.IMultiPieceShipment) => {
		if (this.state.multiPieceShipments?.length > 0) {
			const shipment = this.state.shipment;
			return (
				<Grid container={true} direction='row' justifyContent='space-evenly' spacing={1}>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='subtitle2'>
							<Grid container={true} direction='row' justifyContent='flex-start' alignItems='center'>
								<Grid item={true}>
									{this.props.intl.formatMessage({
										id: 'app.common.json-label',
									})}
								</Grid>
							</Grid>
						</Typography>
					</Grid>
					<Grid item={true} xs={6} style={{ marginTop: '-8px' }}>
						<Typography className='ellipsis' variant='subtitle2'>
							<Grid container={true} direction='row' justifyContent='flex-end' alignItems='center'>
								<Grid item={true}>
									{this.props.intl.formatMessage({
										id: 'app.shipment.package-label',
									})}
								</Grid>

								<Grid item={true}>
									<PageNavigationComponent
										totalPages={this.state.totalPackages}
										page={this.state.packageCurrentPage || 1}
										onChangePage={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, page) => {
											const packageNumber = shipment.packages[page - 1]?.packageNumber;
											this.setState({ reprintPackageNumber: packageNumber });
											const preExistPackage = this.state.multiPieceShipments.find(
												(x) => x.package.packageNumber === packageNumber
											);
											if (!preExistPackage) {
												this.getShipmentByKeyValue(
													multiPieceShipment?.shipmentId,
													packageNumber,
													multiPieceShipment?.accountId
												);
											}

											this.setState({
												shipment,
												packageCurrentPage: page,
												packageNumber,
											});
										}}
									/>
								</Grid>
								<Grid item={true}>of {this.state.totalPackages}</Grid>
							</Grid>
						</Typography>
					</Grid>
					{this.renderJson(multiPieceShipment)}
				</Grid>
			);
		}
		return null;
	};

	private renderJson = (shipment: models.IMultiPieceShipment) => {
		const makeShipmentObj = {
			...this.props.shipment,
			...shipment,
		};

		delete makeShipmentObj.package;
		delete makeShipmentObj.totalPackages;
		delete makeShipmentObj.shipmentId;

		if (!makeShipmentObj.rates) {
			delete makeShipmentObj.rates;
		}
		if (!makeShipmentObj.tracking.additionalTrackingNumber) {
			delete makeShipmentObj.tracking.additionalTrackingNumber;
		}
		if (!makeShipmentObj.tracking.additionalTrackingBarcodeNumber) {
			delete makeShipmentObj.tracking.additionalTrackingBarcodeNumber;
		}

		return (
			<>
				<Grid item={true} xs={12}>
					<Box border={1} padding='10px'>
						<div style={{ height: '325px', overflow: 'auto' }}>
							<ReactJson
								displayDataTypes={false}
								src={makeShipmentObj}
								enableClipboard={false}
								shouldCollapse={(field: CollapsedFieldProps) => {
									return CollapsedFieldsInJsonView.includes(field.name);
								}}
							/>
						</div>
					</Box>
				</Grid>
			</>
		);
	};
	// get address
	private getToAddress = (toAddress: models.IAddress) => (
		<>
			<Typography className='ellipsis' variant='subtitle2'>
				{this.props.intl.formatMessage({
					id: 'app.shipment.toAddress',
				})}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.name}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.street1}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.street2}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.city}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.state}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.zip}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{toAddress.country}
			</Typography>
		</>
	);

	// get from address details
	private getFromAddress = (fromAddress: models.IAddress) => (
		<>
			<Typography className='ellipsis' variant='subtitle2'>
				{this.props.intl.formatMessage({
					id: 'app.shipment.fromAddress',
				})}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.name}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.street1}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.street2}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.city}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.state}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.zip}
			</Typography>
			<Typography className='ellipsis' variant='body2'>
				{fromAddress.country}
			</Typography>
		</>
	);

	private getOtherInfo = (shipmentItem: models.IShipment) => {
		let clientFee = 0;
		let partnerFee = 0;
		let clientFeeIncludingOtherCharges = 0;
		let partnerFeeIncludingOtherCharges = 0;
		let creditCardFee = 0;
		shipmentItem.rates?.[0]?.fees.map((x) => {
			switch (x.type) {
				case CostTypeEnum.ClientFee:
					clientFee = clientFee + x.fee;
					clientFeeIncludingOtherCharges = clientFeeIncludingOtherCharges + x.feeIncludingOtherCharges;
					break;

				case CostTypeEnum.PartnerFee:
					partnerFee = partnerFee + x.fee;
					partnerFeeIncludingOtherCharges = partnerFeeIncludingOtherCharges + x.feeIncludingOtherCharges;
					break;

				case CostTypeEnum.CreditCardFee:
					creditCardFee = creditCardFee + x.fee;
					break;
			}
		});

		const gridItemsArray = [];

		{
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6} className='background-grey-color-light'>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.serviceType',
							})}
						</Typography>
					</Grid>
					<Grid item={true} xs={6} className='background-grey-color-light'>
						<Typography className='ellipsis' variant='body2'>
							{shipmentItem.service}
						</Typography>
					</Grid>
				</>
			);
		}

		if (shipmentItem.specialService?.length > 0) {
			shipmentItem.specialService.map((x) => {
				gridItemsArray.push(
					<>
						<Grid item={true} xs={6}>
							<Typography className='ellipsis' variant='body2'>
								{this.props.intl.formatMessage({
									id: 'app.shipment.special-service',
								})}
							</Typography>
						</Grid>
						<Grid item={true} xs={6}>
							<Typography className='ellipsis' variant='body2'>
								{x}
							</Typography>
						</Grid>
					</>
				);
			});
		}

		{
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.ship-date',
							})}
						</Typography>
					</Grid>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='body2'>
							<FormattedDate {...dateTimeFormatOptions} value={shipmentItem.shipDate} />
						</Typography>
					</Grid>
				</>
			);
		}

		if (creditCardFee) {
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6} className='background-grey-color-light'>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.rate-credit-fee-label',
							})}
						</Typography>
					</Grid>
					<Grid item={true} xs={6} className='background-grey-color-light'>
						<Typography className='ellipsis' variant='body2'>
							{' '}
							$
							<FormattedNumber value={creditCardFee} maximumFractionDigits={2} minimumFractionDigits={2} />
						</Typography>
					</Grid>
				</>
			);
		}
		if (clientFee || (!shipmentItem.rates && accountService.IsAdmin())) {
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.rate-client-fee-label',
							})}
							{shipmentItem.rates ? (
								<FormControlLabel
									control={
										<Checkbox
											checked={this.state.isIncludeOtherClientFeeCharges}
											style={{ padding: '0px' }}
											size='small'
											onChange={(e) => {
												this.setState((prevState) => ({
													isIncludeOtherClientFeeCharges: !prevState.isIncludeOtherClientFeeCharges,
												}));
											}}
										/>
									}
									style={{ marginLeft: 5 }}
									label={
										<Typography className='ellipsis' variant='body2'>
											{this.props.intl.formatMessage({ id: 'app.admin.shipment-include-other-charges' })}
										</Typography>
									}
								/>
							) : null}
						</Typography>
					</Grid>
					<Grid item={true} xs={6}>
						{!shipmentItem.rates ? (
							<Typography className='ellipsis' variant='body2'>
								{this.props.intl.formatMessage({ id: 'app.shipment.rate-column-norated' })}
							</Typography>
						) : (
							<Typography className='ellipsis' variant='body2'>
								$
								<FormattedNumber
									value={this.state.isIncludeOtherClientFeeCharges ? clientFeeIncludingOtherCharges : clientFee}
									maximumFractionDigits={2}
									minimumFractionDigits={2}
								/>
							</Typography>
						)}
					</Grid>
				</>
			);
		}

		if (partnerFee || (!shipmentItem.rates && accountService.IsAdmin())) {
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6} className='background-grey-color-light'>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.rate-partner-fee-label',
							})}

							{shipmentItem.rates ? (
								<FormControlLabel
									control={
										<Checkbox
											checked={this.state.isIncludeOtherPartnerFeeCharges}
											style={{ padding: '0px' }}
											size='small'
											onChange={(e) => {
												this.setState((prevState) => ({
													isIncludeOtherPartnerFeeCharges: !prevState.isIncludeOtherPartnerFeeCharges,
												}));
											}}
										/>
									}
									style={{ marginLeft: 5 }}
									label={
										<Typography className='ellipsis' variant='body2'>
											{this.props.intl.formatMessage({ id: 'app.admin.shipment-include-other-charges' })}
										</Typography>
									}
								/>
							) : null}
						</Typography>
					</Grid>

					<Grid item={true} xs={6} className='background-grey-color-light'>
						{!shipmentItem.rates ? (
							<Typography className='ellipsis' variant='body2'>
								{this.props.intl.formatMessage({ id: 'app.shipment.rate-column-norated' })}
							</Typography>
						) : (
							<Typography className='ellipsis' variant='body2'>
								$
								<FormattedNumber
									value={this.state.isIncludeOtherPartnerFeeCharges ? partnerFeeIncludingOtherCharges : partnerFee}
									maximumFractionDigits={2}
									minimumFractionDigits={2}
								/>
							</Typography>
						)}
					</Grid>
				</>
			);
		}

		if (accountService.getUserData().user.role === UserRole.AccountAdmin) {
			gridItemsArray.push(
				<>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='body2'>
							{this.props.intl.formatMessage({
								id: 'app.shipment.transactionId',
							})}
						</Typography>
					</Grid>
					<Grid item={true} xs={6}>
						<Typography className='ellipsis' variant='body2'>
							{shipmentItem.transactionId}
						</Typography>
					</Grid>
				</>
			);
		}

		return (
			<>
				<Typography className='ellipsis' variant='subtitle2'>
					{this.props.intl.formatMessage({
						id: 'app.shipment.otherInfo',
					})}
				</Typography>
				<Grid container={true} direction='row'>
					{gridItemsArray.map((eachRow, index) => {
						return (
							<Grid key={index} item={true} xs={12} className={index % 2 === 0 ? 'background-grey-color-light' : ''}>
								<Grid container={true}>{eachRow}</Grid>
							</Grid>
						);
					})}
				</Grid>
			</>
		);
	};

	private downloadButtons = (item: models.IShipment, multiPieceShipment: models.IMultiPieceShipment[]) => {
		return (
			<Grid container={true} spacing={3}>
				{!accountService.IsAdmin() ? (
					<>
						<Grid item={true}>
							<CustomButton
								variant={ButtonVariantEnum.Outlined}
								color={ButtonColorEnum.Primary}
								disabled={!!this.state.shipment.refundStatus}
								onClick={() =>
									this.setState({
										isOpenRefundStatusDialog: true,
									})
								}
								buttonText={this.props.intl.formatMessage({
									id: 'app.shipment.refund-button-text',
								})}
							/>
						</Grid>
						<Grid item={true}>
							<CustomButton
								variant={ButtonVariantEnum.Outlined}
								color={ButtonColorEnum.Primary}
								onClick={() => {
									if (this.state.totalPackages > 1) {
										this.setState({
											isOpenReprintLabelDialog: true,
											reprintLabelQuantity: ReprintLabelPackageSelectionEnum.Specific,
										});
									} else {
										this.reprintLabel(multiPieceShipment[0].shipmentId, multiPieceShipment[0].postageLabel);
									}
								}}
								buttonText={this.props.intl.formatMessage({
									id: 'app.shipment.reprint-label',
								})}
							/>
						</Grid>
					</>
				) : null}
				{accountService.IsAdmin() && CarriersSupportingScanForm.includes(this.state.shipment.carrierCode) && (
					<Grid item={true}>
						<CustomButton
							disabled={!this.state.shipment.manifestId}
							onClick={async () =>
								await this.manifestCarrierFile(item.manifestId, AdminDownloadFileTypeEnum.ManifestDocument)
							}
							variant={ButtonVariantEnum.Outlined}
							color={ButtonColorEnum.Primary}
							buttonText={this.props.intl.formatMessage({
								id: 'app.shipment.manifest-button-text',
							})}
						/>
					</Grid>
				)}
				{accountService.IsAdmin() && (
					<Grid item={true}>
						<CustomButton
							variant={ButtonVariantEnum.Outlined}
							color={ButtonColorEnum.Primary}
							disabled={!this.state.shipment.manifestId}
							onClick={async () =>
								await this.manifestCarrierFile(item.manifestId, AdminDownloadFileTypeEnum.CarrierFile)
							}
							buttonText={this.props.intl.formatMessage({
								id: 'app.shipment.carrier-file-button-text',
							})}
						/>
					</Grid>
				)}
				<Grid item={true}>
					<CustomButton
						disabled={!this.state.shipment.tracking}
						onClick={async () => await this.updateTracking(item.id)}
						buttonText={this.props.intl.formatMessage({
							id: 'app.shipment.update-tracking-button-text',
						})}
					/>
				</Grid>
			</Grid>
		);
	};

	private reprintLabel(shipmentId: string, postageLabel: models.IPostageLabel): void | PromiseLike<void> {
		return postageLabel?.labels.forEach((labelUrlOrDataString) => {
			const link = document.createElement('a');
			link.target = '_blank';
			link.href = labelUrlOrDataString;
			if (postageLabel?.labelType === LabelTypeEnum.Base64) {
				link.download = `Label-${shipmentId}.${postageLabel?.labelFileType.toLowerCase()}`;
				link.href = `data:application/octet-stream;base64,` + labelUrlOrDataString;
			}
			link.click();
		}, this);
	}

	// create refund a label
	private refundShipment = async (id: string) => {
		try {
			this.setState({
				isShipmentRefundLoading: true,
			});
			const refundResult = await shipmentService.createRefundShipment(id);
			if (this.props.onShipmentUpdate) {
				this.props.onShipmentUpdate(refundResult);
			}
			this.setState({
				shipment: refundResult,
			});
			this.props.openSnackBar(
				this.props.intl.formatMessage({
					id: 'app.shipment.refund-shipment-status-snackbar',
				})
			);
		} catch (err) {
			if (!Axios.isCancel(err)) {
				this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};

	private getShipmentByKeyValue = async (value: string, packageNumber?: number, accountId?: string) => {
		try {
			this.setState({
				packageLoading: true,
			});

			let shipment;
			if (!accountService.IsAdmin()) {
				shipment = await shipmentService.getShipment(
					GetTypeEnum.ShipmentId,
					value,
					packageNumber,
					this.props.axiosCancellationToken
				);
			} else {
				shipment = await adminReportService.getShipmentForAdmin(
					GetTypeEnum.ShipmentId,
					value,
					packageNumber,
					accountId,
					this.props.axiosCancellationToken
				);
			}

			this.setState({
				shipment,
				packageNumber,
				packageLoading: false,
			});
		} catch (err) {
			if (!Axios.isCancel(err)) {
				this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};

	// get manifest document and carrier file
	private manifestCarrierFile = async (manifestId: string, adminDownloadFileType: AdminDownloadFileTypeEnum) => {
		try {
			const manifestCarrierFileResult = await adminManifestService.getManifestCarrierFile(
				manifestId,
				adminDownloadFileType
			);
			if (manifestCarrierFileResult) {
				window.open(manifestCarrierFileResult);
			}
		} catch (err) {
			if (!Axios.isCancel(err)) {
				this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};

	// get updated tracking data
	private updateTracking = async (shipmentId: string) => {
		try {
			const trackingData = await trackingService.getTracking(GetTypeEnum.ShipmentId, shipmentId);

			const shipment = {
				...this.state.shipment,
				tracking: {
					...this.state.shipment.tracking,
					status: trackingData.status,
					subStatus: trackingData.subStatus,
					trackingNumber: trackingData.trackingNumber,
					trackingBarcodeNumber: trackingData.trackingBarcodeNumber,
					additionalTrackingNumber: trackingData.additionalTrackingNumber,
					additionalTrackingBarcodeNumber: trackingData.additionalTrackingBarcodeNumber,
					trackingUrl: trackingData.trackingUrl,
				},
			};

			if (this.props.onShipmentUpdate) {
				this.props.onShipmentUpdate(shipment);
			}

			this.setState((prevState) => ({ ...prevState, shipment }));

			this.props.openSnackBar(
				this.props.intl.formatMessage(
					{ id: 'app.shipment.update-tracking-success' },
					{
						trackingNumber: trackingData.trackingNumber,
					}
				),
				SnackBarVariants.Success
			);
		} catch (err) {
			if (!Axios.isCancel(err)) {
				this.props.openSnackBar(sharedService.parseError(err.data), SnackBarVariants.Error);
			}
		}
	};
}
export default withAxiosCancellation(withSnackBar(injectIntl(ShipmentDetailComponent)));



// WEBPACK FOOTER //
// ./src/components/shared/shipment-detail.component.tsx